import XDate from 'xdate'

/**
 * Formats a message timestamp relative to now — time today, weekday this
 * week, else a short date.
 *
 * @param {number} timestamp
 * @returns {string}
 */
const formatMessageTime = (timestamp: number): string => {
  if (timestamp <= 0) {
    return ''
  }

  const now = new XDate()
  const then = new XDate(timestamp)

  if (now.toString('yyyy-MM-dd') === then.toString('yyyy-MM-dd')) {
    return then.toString('h:mm TT')
  }

  if (now.diffDays(then) > -7) {
    return then.toString('ddd h:mm TT')
  }

  return then.toString('MMM d')
}

export { formatMessageTime }
